import styled from '@emotion/styled'

export const StyleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
`

export const StyleGridItem = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  padding: 10px;
  border-radius: 4px;
  position: relative;
`

export const styleDocumentUploadWrapper = `
    background:#E9E9E9;
    border-radius:8px;
    div{
        display:flex;
        flex-direction:column;
        button{
            height:80px;
            display:flex;
            flex-direction:column;
            justufy-content:center;
            align-items:center;
            row-gap:5px;
            color:#4B4B4B;
        }
    }
`

export const styleCircle = `
    position:absolute;
    top:-10px;
    right:-10px;
`
